import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import BoxCard from "shared/components/box/BoxCard.js";
import ControllerClubs2 from "shared/components/controllers/ControllerClubs2";
import { getClubs } from "shared/services/api-assistant.js";
import MiscClubPerformance from "shared/components/misc/MiscClubPerformance";

const PageUserPerformance = () => {
  const user = useOutletContext();

  const [clubs, setClubs] = useState(null);
  const [selectedClub, setSelectedClub] = useState(null);

  const fetchClubs = () => {
    getClubs({
      handleSuccess: (d) => {
        const c = d.data.getClubs.sort((a, b) => a.division - b.division);
        setClubs(c);
        setSelectedClub(c[0]);
      },
      handleError: console.log,
      params: { owners: [user.id], considerStaffMembers: true },
    });
  };

  useEffect(() => {
    if (user) fetchClubs();
  }, [user]);

  return (
    <div id="PageUserClubs">
      <div className="container-fluid px-1 px-md-4 py-4">
        <div className="d-flex flex-column flex-md-row">
          <div className="flex-shrink-0">
            <BoxCard
              className="fit-content"
              title="Clubs"
              content={
                <ControllerClubs2
                  onSelect={(c) => setSelectedClub(c)}
                  userId={user.id}
                  selectedClubId={selectedClub?.id}
                />
              }
            />
          </div>

          <div className="d-flex flex-column flex-fill">
            {selectedClub && <MiscClubPerformance clubId={selectedClub.id} clubType={selectedClub.type} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageUserPerformance;
